import { render, staticRenderFns } from "./SiteIntro.vue?vue&type=template&id=861cd504"
import script from "./SiteIntro.vue?vue&type=script&lang=js"
export * from "./SiteIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports